'use client';

import { isDesktop } from 'react-device-detect';

import clsx from 'clsx';

import { Image } from '@/components/Image';

import styles from '@/views/MovieDetailsView/MovieDetailsSnapshotsView/MovieDetailsSnapshotsView.module.scss';

// =================================================================

const SNAPSHOT_ASPECT_RATIO = 281 / 172;

// =================================================================

interface SnapshotCardProps {
  src: string;
  onClick: () => void;
}

// =================================================================

export const SnapshotCard = (props: SnapshotCardProps) => {
  const { src, onClick } = props;

  return (
    <Image
      as="div"
      role="button"
      tabIndex={-1}
      src={src}
      alt="Кадр из фильма"
      aspectRatio={SNAPSHOT_ASPECT_RATIO}
      wrapperClassName={clsx(styles.snapshotWrapper, isDesktop && styles.hovered)}
      fill
      onClick={onClick}
    />
  );
};
